// Fix round 1 (task-3-review-r1 #1): mirrors the backend wallet-number format check
// (backend/src/main/java/com/kervolt/oms/payroll/service/MfsDisbursementService.java
// WALLET_PATTERN / "Invalid wallet number format") so a bad mobile banking account number is
// rejected client-side with the same wording, rather than only surfacing at disbursement time.
export const MOBILE_WALLET_PATTERN = /^01[3-9]\d{8}$/;

export const MOBILE_WALLET_INVALID_MESSAGE = 'Invalid wallet number format';

/** Blank is valid (the field is optional) — only a non-blank value must match the pattern. */
export function isValidMobileWalletNumber(value: string): boolean {
    return value.trim() === '' || MOBILE_WALLET_PATTERN.test(value.trim());
}

/**
 * Canonical mobile-financial-service providers. The spelling matches what the MFS disbursement
 * export matches on (MfsDisbursementService: case-insensitive "bkash" / "nagad") and what the
 * backend stores (UserProfileService.MOBILE_PROVIDERS).
 */
export const MOBILE_PROVIDERS = ['bKash', 'Nagad', 'Rocket', 'Upay'] as const;

/** True for a non-blank stored value that is not one of the canonical providers (old free text). */
export function isLegacyMobileProvider(value: string | null | undefined): boolean {
    const v = (value ?? '').trim();
    return v !== '' && !(MOBILE_PROVIDERS as readonly string[]).includes(v);
}

export const LEGACY_PROVIDER_HINT = 'Not a standard provider - pick one from the list to re-save it.';
